module.exports = __webpack_public_path__ + "static/media/1014810.e56dea45.jpg";